import React, { useState, useEffect, useRef } from 'react';
import { Space, Button, Steps, Select, message, Form, Input, Spin } from "antd";
import { getSchoolListInfo, postAuthBindInfo } from '../../services/business-service/auth-bind';
import { getUserInfo, checkUserInfo } from '../../services/business-service/user';
import { logout } from '../../services/business-service/auth';
import { RealModal } from "../modal";
import { regexpName, regexpCode } from '../../utils/regExp';
import { HttpResponseCode, InitState, SERVICE_KEY, TOKEN_KEY } from '../../constant';
import LogOut from "./log-out";
import AuthFailed from "./auth-failed";
import GlobalImage from '../imgComponent/index';
import { getTime } from '../../utils/time'
import './style';

const currentYear = new Date().getFullYear();

// 计算前后三年的年份
const years = [
  currentYear - 3,  // 前三年
  currentYear - 2,  // 前两年
  currentYear - 1,  // 前一年
  currentYear,      // 当前年
  currentYear + 1,  // 后一年
  currentYear + 2,  // 后两年
  currentYear + 3   // 后三年
];

const AuthStep = {
  firstStep: 0,
  secondStep: 1,
}
// const RoleType = {
//   student: 0,
//   teacher: 1
// };

const { Step } = Steps;
const { Option } = Select;

const AuthBind = ({ tokenObj }) => {
  const modalInstance = useRef(null);
  const [isModalStatus, setIsModalStatus] = useState(false);
  // 设置当前的显示step
  const [currentStep, setCurrentStep] = useState(AuthStep.firstStep);
  // 学校 appSchId
  const [selectedSchoolId, setSelectedSchoolId] = useState();
  // 用户角色
  const [roleType, setRoleType] = useState(0);
  const [userForm] = Form.useForm();
  const initialValues = {
    code: '',
    name: '',
    gradeName: currentYear,
  };
  const codeTip = roleType === 0 ? '请填写正确的学号' : '请填写正确的工号';
  const unipusUserTip = '当前账号未在U校园认证，建议使用U校园账号登录';

  /**
   * 校验 U 校园账号
   */
  const [loading, setLoading] = useState(false);
  const [showUnipusUserTip, setShowUnipusUserTip] = useState(false);
  const getUnipusUserInfo = async () => {
    if (showUnipusUserTip) {
      return;
    }
    setLoading(true);
    try {
      const tmp = tokenObj?.jwt?.split('.')?.[1];
      const { openId } = JSON.parse(window.atob(tmp) || '{}');
      const { code, value } = await checkUserInfo({ roleType: 1, openId });
      setLoading(false);
      const { openId: unipusOpenId } = value || {};
      if (code === 1 && !unipusOpenId) {
        setShowUnipusUserTip(true);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const setRoleTypeHandle = (num) => {
    setRoleType(num);
    userForm.resetFields();
    // if(
    //   num === 0 && !isXnSchool
    // ){
    //   userForm.setFieldsValue({
    //     gradeName: currentYear,
    //   })
    // }
    if (num === 1) {
      getUnipusUserInfo();
    }
  };

  /**
   * 获取user info
   */
  // const [userInfo, setUserInfo] = useState();
  const toHomepage = () => {
    // const homepage = process.env.REACT_APP_HOMEPAGE || 'https://uai.unipus.cn/home';
    // window.location.assign(homepage);
    window.location.pathname = '/home';
  };
  const fetchUserInfo = async () => {
    // modalInstance.current.setSpinning(true);
    const { code, message: msg, value } = await getUserInfo();
    // modalInstance.current.setSpinning(false);
    if (code === 1) {
      const { userInfo } = value || {};
      InitState.unserInfo = userInfo;
      // setUserInfo(userInfo);
      toHomepage();
    } else if (code === HttpResponseCode.USER_BIND_HAS_NOT) {
      setIsModalStatus(true);

    } else if (code === HttpResponseCode.USER_HAS_LOGGED_OUT) {
      localStorage.removeItem(TOKEN_KEY);
      InitState.tokenInfo = null;
    } else if (code === HttpResponseCode.USER_STATUS_DISABLED) {
      toHomepage();
    } else {
      message.error(msg);
      localStorage.removeItem(TOKEN_KEY);
      InitState.tokenInfo = null;
      logout();
    }
  };
  useEffect(() => {
    if (tokenObj) {
      fetchUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenObj]);

  const [schoolData, setSchoolData] = useState();
  const [schoolTop, setSchoolTop] = useState(); // 置顶虚拟学校数据
  const [isXnSchool, setIsXnSchool] = useState(false); // 是否选择虚拟学校
  const [xnSchool, setXnSchool] = useState(); // 虚拟大学列表
  const getSchoolListData = async (search) => {
    modalInstance.current.setSpinning(true);
    const { code, msg, value } = await getSchoolListInfo();
    modalInstance.current.setSpinning(false);
    if (code === 1) {
      const { listData, topData } = value || {};
      let tmp = listData;
      let xnData;
      if (search) {
        tmp = listData.filter(item => item.name.indexOf(search) !== -1 || search.indexOf(item.name) !== -1);
      }
      xnData = listData.filter(item => item.unipusCode.startsWith('XN'));
      setSchoolData(tmp);
      setSchoolTop(topData); // 置顶学校列表
      setXnSchool(xnData);  // 虚拟大学列表
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    // 获取学校列表数据
    if (isModalStatus) {
      getSchoolListData();
    }
  }, [isModalStatus]);

  const toPrevStep = () => {
    setCurrentStep(AuthStep.firstStep);
  };
  const toNextStep = () => {
    if (!selectedSchoolId) {
      message.warn('请先选择学校，再点击下一步~');
      return;
    }
    setCurrentStep(AuthStep.secondStep);
    // if (!isXnSchool && roleType === 0) {
    //   userForm.setFieldsValue({
    //     gradeName: currentYear,
    //   })
    // }
  };

  /**
   * 选择学校
   */
  const onSelectChangeHandle = (value) => {
    // console.log(`===selected ${value}`);
    let xnSch;
    xnSch = xnSchool.some(item => item.appSchId === value);
    setSelectedSchoolId(value);
    setIsXnSchool(xnSch);
  };

  const onSelectSearchHandle = (value) => {
    // console.log('search:', value);
    getSchoolListData(value);
  };
  /**
   * 关闭退出
   */
  const [showLogOut, setShowLogOut] = useState(false);
  const onLogOutOkHandle = () => {
    setShowLogOut(false);
    setIsModalStatus(false);
    // setUserInfo(undefined);
    setCurrentStep(undefined);
    setSelectedSchoolId(undefined);
    setRoleType(undefined);
    setSchoolData(undefined);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SERVICE_KEY);
    InitState.tokenInfo = null;
    logout();
  };
  const onLogOutCancelHandle = () => {
    setShowLogOut(false);
  };
  /**
   * 关闭Modal
   */
  const handleCancelModal = () => {
    setShowLogOut(true);
  };

  /**
   * 认证失败
   */
  const [showAuthFailed, setShowAuthFailed] = useState(false);
  const [authFailedTips, setAuthFailedTips] = useState();
  const [authFailedTitle, setAuthFailedTitle] = useState();
  const getTips = (code) => {
    switch (code) {
      case 5020:
        return (
          <>
            <p>可能由以下原因造成认证失败：</p>
            <p>1. {roleType === 0 ? '学号' : '工号'}或姓名输入错误，请检查后重新输入</p>
            <p>2. {roleType === 0 ? '学号' : '工号'}和姓名未导入系统，请联系学校管理员导入信息</p>
            {/* <p>3. 学校未开通U校园AI版平台</p> */}
          </>
        );
      case 5023:
        return (
          <>
            <p>可能由以下原因造成认证失败：</p>
            <p>1. 学校未开通U校园AI版平台</p>
          </>
        );
      default:
        return '';
    }
  };
  const getTitle = (code) => {
    switch (code) {
      case 5020:
        return '认证失败';
      case 2099:
      case 3207:
        return '提交失败';
      default:
        return '认证失败';
    }
  };
  const authFailedFooter = (
    <Button
      className="confirm-btn"
      onClick={() => {
        setShowAuthFailed(false);
        setAuthFailedTips(undefined);
      }}
    >
      确定
    </Button>
  );
  /**
   * 提交
   */
  const submitHandle = async () => {
    userForm.validateFields().then(async (formData) => {
      modalInstance.current.setSpinning(true);
      const { code: userCode, name, gradeName } = formData || {};
      const { code, msg } = await postAuthBindInfo({ appId: 116, school: selectedSchoolId, code: userCode || getTime(), name, roleType, gradeName });
      modalInstance.current.setSpinning(false);
      if (code === 1) {
        message.success('认证成功！');
        toHomepage();
      } else if (code === 5020) {
        setAuthFailedTips(getTips(5020));
        setAuthFailedTitle(getTitle(5020));
        setShowAuthFailed(true);
      } else if (code === 5023) {
        message.error('学校未开通U校园AI版平台');
      } else if (code === 5000) {
        message.error('网络不稳定，请稍后再试');
      } else if (code === 2099 || code === 3207) {
        setAuthFailedTips(<p className='tipsreg' style={{ textAlign: 'left' }}>{msg}</p>);
        setAuthFailedTitle(getTitle(code));
        setShowAuthFailed(true);
      } else {
        message.error(msg);
      }
    });
  };

  const footer = (
    <div className="footer">
      <Space size={16}>
        <Button
          onClick={toPrevStep}
          className="prev-btn"
          disabled={currentStep === AuthStep.firstStep || loading}
        >
          上一步
        </Button>
        <Button
          type="primary"
          className="confirm-btn"
          disabled={loading}
          onClick={() => {
            // if (needValidate) {
            //   onOk(setSpinning);
            //   return;
            // }
            // setSpinning(true);
            // onOk();
            currentStep === AuthStep.firstStep
              ? toNextStep()
              : submitHandle()
          }}
        >
          {currentStep === AuthStep.firstStep ? '下一步' : '提交'}
        </Button>
      </Space>
    </div>
  );

  return (
    <div className="auth-bind-wrap">
      <RealModal
        // title="身份认证"
        title="填写信息"
        ref={modalInstance}
        visible={isModalStatus}
        width={960}
        centered
        wrapperClassName="auth-bind-modal"
        onCancel={handleCancelModal}
        onOk={() => { }}
        footer={footer}
      >
        <Spin spinning={loading}>
          <div className="wrap">
            <div className="steps">
              <Steps
                current={currentStep}
              >
                <Step title="选择学校" />
                {/* <Step title="认证身份" /> */}
                <Step title="个人信息" />
              </Steps>
            </div>
            {currentStep === AuthStep.firstStep && (
              <div className="college-select">
                选择学校：
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="请选择你的学校"
                  value={selectedSchoolId}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onChange={onSelectChangeHandle}
                  onSearch={onSelectSearchHandle}
                >
                  {
                    schoolTop?.map(one => (
                      <Option key={one.appSchId} value={one.appSchId}>
                        {one.name}
                      </Option>
                    ))
                  }
                  {
                    schoolData?.map(one => (
                      <Option key={one.appSchId} value={one.appSchId}>
                        {one.name}
                      </Option>
                    ))
                  }
                </Select>
              </div>
            )}
            {currentStep === AuthStep.secondStep && (
              <div className="chose-role-type">
                <div className="school-name">{schoolData?.filter(one => one.appSchId === selectedSchoolId)[0]?.name}</div>
                <div className="role-type">
                  <div className={roleType === 0 ? "role stu active" : "role stu"} onClick={() => setRoleTypeHandle(0)}>
                    <GlobalImage src={roleType === 0 ? 'stu-active.png' : 'stu.png'} alt="学生" />
                    <p>我是学生</p>
                  </div>
                  <div className={roleType === 1 ? "role tch active" : "role tch"} onClick={() => setRoleTypeHandle(1)}>
                    <GlobalImage src={roleType === 1 ? 'tch-active.png' : 'tch.png'} alt="教师" />
                    <p>我是老师</p>
                    {roleType === 1 && showUnipusUserTip && (
                      <div className="unipus-user-tip">
                        <GlobalImage src='warning.png' alt="warning" />
                        <span>{unipusUserTip}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="user-form">
                  <Form form={userForm} initialValues={initialValues} validateTrigger="onBlur">
                    {
                      isXnSchool || (<Form.Item
                        label={roleType === 0 ? '学号' : '工号'}
                        name="code"
                        rules={[
                          { required: true, message: codeTip },
                          {
                            validator(rule, value) {
                              if (regexpCode(value)) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(codeTip);
                              }
                            },
                          },
                        ]}
                      >
                        <Input placeholder={roleType === 0 ? '请填写学号' : '请填写工号'} autoComplete="off" />
                      </Form.Item>)
                    }
                    <Form.Item
                      label="姓名"
                      name="name"
                      rules={[
                        { required: true, message: '请填写正确的姓名' },
                        {
                          validator(rule, value) {
                            if (regexpName(value)) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('请填写正确的姓名');
                            }
                          },
                        },
                      ]}
                    >
                      <Input placeholder="请填写姓名" autoComplete="off" />
                    </Form.Item>
                    {
                      (roleType === 0 && !isXnSchool) ? (
                        <Form.Item
                          label="年级"
                          name="gradeName"
                          rules={[
                            { required: true, message: '请选择年级' },
                          ]}
                        >
                          <Select
                            placeholder="请选择年级"
                          >
                            {
                              years.map((year)=>{
                                return <Option value={year} key={year}>
                                  {year}
                                </Option>
                              })
                            }
                          </Select>
                        </Form.Item>
                      ) : null
                    }
                  </Form>
                </div>
              </div>
            )}
          </div>
        </Spin>
      </RealModal>
      <LogOut
        open={showLogOut}
        onOk={onLogOutOkHandle}
        onCancel={onLogOutCancelHandle}
      />
      <AuthFailed
        open={showAuthFailed}
        onOk={() => setShowAuthFailed(false)}
        tips={authFailedTips}
        footer={authFailedFooter}
        title={authFailedTitle}
      />
    </div>
  );
}

export default AuthBind;
